export const CALL_FOLLOW_UP_FIELD = "CallFollowUp";

export const readCallFollowUp = (lead = {}) => {
  const value = lead?.[CALL_FOLLOW_UP_FIELD];
  return value && typeof value === "object" ? value : null;
};

export const readCallFollowUpState = (lead, now = new Date()) => {
  const followUp = readCallFollowUp(lead);
  if (!followUp || followUp.status !== "scheduled" || !followUp.scheduledAt) return "none";

  const scheduledAt = new Date(followUp.scheduledAt);
  if (Number.isNaN(scheduledAt.getTime())) return "none";

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const scheduledDay = new Date(scheduledAt.getFullYear(), scheduledAt.getMonth(), scheduledAt.getDate());
  const dayDifference = Math.round((scheduledDay.getTime() - today.getTime()) / 86400000);

  if (scheduledAt.getTime() < now.getTime()) return "overdue";
  if (dayDifference === 0) return "today";
  if (dayDifference === 1) return "tomorrow";
  return "upcoming";
};

export const formatCallFollowUp = (lead, t = (value) => value, locale, now = new Date()) => {
  const followUp = readCallFollowUp(lead);
  const state = readCallFollowUpState(lead, now);
  if (!followUp || state === "none") return "";

  const scheduledAt = new Date(followUp.scheduledAt);
  const time = scheduledAt.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  if (state === "today") return `${t("Call today")} · ${time}`;
  if (state === "tomorrow") return `${t("Call tomorrow")} · ${time}`;
  if (state === "overdue") return `${t("Call overdue")} · ${scheduledAt.toLocaleDateString(locale)} ${time}`;
  return `${t("Call")} · ${scheduledAt.toLocaleDateString(locale)} ${time}`;
};

export const toDateTimeLocalValue = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return offsetDate.toISOString().slice(0, 16);
};
